import { render } from "./SelectFont.vue?vue&type=template&id=3984da36&scoped=true"
import script from "./SelectFont.vue?vue&type=script&lang=js"
export * from "./SelectFont.vue?vue&type=script&lang=js"

import "./SelectFont.vue?vue&type=style&index=0&id=3984da36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3984da36"]])

export default __exports__